import React, { useState } from "react";
import useTutorialsState from "../../hooks/useTutorialsState";

export function useChecklist(accountType, isNmiAccount) {
  const { getHasCompletedTutorial } = useTutorialsState();

  const hasAddedProduct = getHasCompletedTutorial("Add Product");

  const hasAddedStatementDescriptor = getHasCompletedTutorial(
    "Add Statement Descriptor"
  );

  const hasAddedTheme = getHasCompletedTutorial("Add Customized Theme");

  const hasAddedDomain = getHasCompletedTutorial("Add Custom Domain");

  const hasAddedShippingProfile = getHasCompletedTutorial(
    "Add Shipping Profile"
  );

  const hasAddedPoliticalDisclaimer = getHasCompletedTutorial(
    "Add Customized Political Disclaimer"
  );

  const hasFilledProfile = getHasCompletedTutorial(
    "Brand Dashboard Payment Info"
  );

  const hasAddedCustomizedConfirmationEmail = getHasCompletedTutorial(
    "Add Customized Order Confirmation Email"
  );

  const hasAddedVideo = getHasCompletedTutorial("Add Video");

  let totalChecks, progress;
  progress =
    !!hasAddedProduct +
    !!hasAddedTheme +
    !!hasAddedDomain +
    !!hasAddedCustomizedConfirmationEmail;

  if (accountType === "NonProfit") {
    progress = progress + !!hasAddedVideo;
    totalChecks = 5;
  } else if (accountType === "Political") {
    progress = progress + !!hasAddedPoliticalDisclaimer;
    totalChecks = 5;
  } else {
    progress = progress + !!hasAddedVideo + !!hasAddedShippingProfile;
    totalChecks = 6;
  }

  if (!isNmiAccount) {
    progress = progress + !!hasAddedStatementDescriptor + !!hasFilledProfile;
    totalChecks = totalChecks + 2;
  }

  const percentageProgress = parseInt((progress / totalChecks) * 100);

  return {
    hasAddedProduct,
    hasFilledProfile,
    hasAddedStatementDescriptor,
    hasAddedTheme,
    hasAddedDomain,
    hasAddedShippingProfile,
    hasAddedPoliticalDisclaimer,
    hasAddedVideo,
    hasAddedCustomizedConfirmationEmail,
    showChecklist: progress !== totalChecks,
    percentageProgress,
    isNmiAccount
  };
}
